import { createFileRoute } from '@tanstack/react-router';
import { ReorderReport } from '../../../features/purchasing-intake/ReorderReport';

/** Owned by G20. Reorder report (BUILD_SPEC.md §13, §8.6): below-min products
 * grouped by supplier, one-click "create draft PO". */
export const Route = createFileRoute('/_authenticated/purchasing-intake/reorder')({
  component: ReorderReport,
});
